import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Link from '@material-ui/core/Link';
import GoogleMapReact from 'google-map-react';
import RoomIcon from '@material-ui/icons/Room';
import CallIcon from '@material-ui/icons/Call';


import styles from "assets/jss/material-kit-react/views/landingPageSections/contactStyle.js";

const useStyles = makeStyles(styles);

export default function ContactSection() {
  const classes = useStyles();
  const LocationPin = ({ text }) => (
    <div className={classes.pin}>
      <RoomIcon className={classes.pinIcon} />
      <p className={classes.pinText}>{text}</p>
    </div>
  )
  const location = {
    address: '441 E 12th Street, New York, NY 10009',
    lat: 40.72928834494934, 
    lng: -73.98150779332808
  }
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem cs={12} sm={12} md={12}>
          <h2 className={classes.title}>Contact Us</h2>
          <h4 className={classes.description}>
            To book an appointment or for more information call us at <b>(929)-358-8588</b>.<br/>
            You can also message us on <Link href="https://www.instagram.com/liliswaxthreadingstudio/">Instagram</Link> or <Link href="https://www.facebook.com/liliswaxingandthreadingstudio/">Facebook</Link>.
          </h4>
          <GridContainer justify="center">
          <GridItem cs={12} sm={12} md={6}>
            <GridContainer>
              <GridItem xs={12} className={classes.description}>
                <h4 className={classes.pinText}>
                  <RoomIcon style={{fontSize: '3rem'}}/>441 E 12th Street, New York, NY 10009
                </h4>
              </GridItem>
              <GridItem xs={12} className={classes.description}>
                <h4 className={classes.pinText}>
                  <CallIcon style={{fontSize: '3rem'}}/>(929)-358-8588
                </h4>
              </GridItem>
              <GridItem xs={12}>
                <h3 className={classes.title}>
                  Business Hours
                </h3>
              </GridItem>
              <GridItem xs={12} m={6}>
                <h4 className={classes.description}>
                  <b>Monday - Saturday</b>
                </h4>
              </GridItem>
              <GridItem xs={12} m={6}>
                <h4 className={classes.description}>
                  10:00 AM - 8:30 PM
                </h4>
              </GridItem>
              <GridItem xs={12} m={6}>
                <h4 className={classes.description}>
                  <b>Sunday</b>
                </h4>
              </GridItem>
              <GridItem xs={12} m={6}>
                <h4 className={classes.description}>
                  10:30 AM - 7:00 PM
                </h4>
              </GridItem>
            </GridContainer>
            </GridItem>
            <GridItem cs={12} sm={12} md={6}>
              <div className={classes.googleMap}>
                <GoogleMapReact
                bootstrapURLKeys={{key: 'AIzaSyDnXbkHPcTnZ03txMgMfD2lMNs9-DaeWDc'}}
                defaultCenter={location}
                defaultZoom={17}
                >
                  <LocationPin 
                    lat={location.lat}
                    lng={location.lng}
                    text={location.address}
                    />
                </GoogleMapReact>
              </div>
            </GridItem>
          </GridContainer>
          
        </GridItem>
      </GridContainer>
    </div>
  );
}
